import { LEAD_STATUS_META } from "./salesMeta";
import { EmptyState } from "@/components/admin/ui";
import { Inbox } from "lucide-react";

export const LeadList = ({ leads, meta, selectedId, onSelect, filters, onFilterChange }) => (
  <div className="flex h-full flex-col" data-testid="lead-list-column">
    <input
      value={filters.q}
      onChange={(e) => onFilterChange("q", e.target.value)}
      placeholder="Search name, Lead ID, phone, email, service…"
      data-testid="lead-search-input"
      className="mb-2 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm dark:border-white/15 dark:bg-[#0B1220] dark:text-white"
    />
    <div className="mb-3 grid grid-cols-2 gap-1.5">
      <select value={filters.status} onChange={(e) => onFilterChange("status", e.target.value)} data-testid="lead-filter-status" className="rounded-lg border border-slate-200 px-2 py-1.5 text-xs font-semibold dark:border-white/15 dark:bg-[#0B1220] dark:text-white">
        <option value="">All Statuses</option>
        {Object.entries(LEAD_STATUS_META).map(([k, m]) => <option key={k} value={k}>{m.label}</option>)}
      </select>
      <select value={filters.team_id} onChange={(e) => onFilterChange("team_id", e.target.value)} data-testid="lead-filter-team" className="rounded-lg border border-slate-200 px-2 py-1.5 text-xs font-semibold dark:border-white/15 dark:bg-[#0B1220] dark:text-white">
        <option value="">All Teams</option>
        {meta.teams.map((t) => <option key={t.team_id} value={t.team_id}>{t.name}</option>)}
      </select>
    </div>
    <div className="flex-1 overflow-y-auto space-y-1.5" data-testid="lead-list-items">
      {leads.length === 0 ? (
        <EmptyState icon={Inbox} title="No Leads yet." message="Qualify an Intake in Front Desk to see it appear here." testId="lead-list-empty" />
      ) : leads.map((l) => {
        const statusMeta = LEAD_STATUS_META[l.status] || { label: l.status, cls: "" };
        return (
          <button
            key={l.lead_id}
            type="button"
            onClick={() => onSelect(l.lead_id)}
            data-testid={`lead-list-item-${l.lead_id}`}
            className={`block w-full rounded-xl border p-3 text-left transition-colors duration-150 ${selectedId === l.lead_id ? "border-[#0052FF] bg-blue-50 dark:border-[#0052FF] dark:bg-[#0052FF]/10" : "border-slate-200 hover:bg-slate-50 dark:border-white/10 dark:hover:bg-white/5"}`}
          >
            <p className="truncate text-sm font-bold text-slate-900 dark:text-white">{l.first_name} {l.last_name}</p>
            <p className="truncate text-xs text-slate-500 dark:text-slate-400">{l.requested_service_name || "—"}</p>
            <p className="truncate text-xs text-slate-400">{l.confirmed_service_area_name || l.service_area_result?.service_area_name || "—"}</p>
            <div className="mt-1.5 flex items-center justify-between gap-2">
              <span className={`shrink-0 rounded-full border px-2 py-0.5 text-[10px] font-bold ${statusMeta.cls}`}>{statusMeta.label}</span>
              <span className="min-w-0 truncate text-[10px] text-slate-400" title={l.display_id}>{l.display_id}</span>
            </div>
          </button>
        );
      })}
    </div>
  </div>
);
